import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
    "SET_FILTER_START_DATE",
    "SET_FILTER_END_DATE",
    "SET_FILTER_HOME_LOCATION",
);
